import { render, staticRenderFns } from "./AdminInitiatedOnboard.vue?vue&type=template&id=3849125f&scoped=true&"
import script from "./AdminInitiatedOnboard.vue?vue&type=script&lang=js&"
export * from "./AdminInitiatedOnboard.vue?vue&type=script&lang=js&"
import style0 from "./AdminInitiatedOnboard.vue?vue&type=style&index=0&id=3849125f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3849125f",
  null
  
)

export default component.exports